// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".access[data-v-7ad433f8]{display:flex;flex-direction:row}", ""]);
// Exports
module.exports = exports;
